<span
  [pTooltip]="showAction ? (canClick ? 'Exibir detalhes da guia' : 'Lançamento descartado') : null"
  tooltipPosition="right"
  >
  {{ displayValue }}
  @if (showAction) {
    <button
      pButton
      type="button"
      class="p-button-sm p-button-text p-0"
      style="vertical-align: baseline"
      [icon]="icon"
      [disabled]="!canClick"
      (click)="onButtonClick()"
    ></button>
  }
</span>
